import PropTypes from 'prop-types';
import clsx from 'clsx';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles'
import {
    Box,
    Link,
    // Button,
    Drawer,
    Hidden,
    Typography,
    ClickAwayListener,
} from '@material-ui/core';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const useStyles = makeStyles((theme) => {

    return {
        drawer: {
            [theme.breakpoints.up('lg')]: {
                flexShrink: 0,
                width: DRAWER_WIDTH
            }
        },
        drawerPaper: {
            width: DRAWER_WIDTH,
            background: theme.palette.background.default
        },
        doc: {
            padding: theme.spacing(2.5),
            borderRadius: theme.shape.borderRadiusMd,
        },
        logoBanner: {
            backgroundColor: '#142669',
            maxWidth: '100%',
            padding: '40px'
        },
        sideBarContent: {
            padding: '57px 0px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            backgroundColor: '#1E2027'
        },
        links: {
            height: '40px',
            maxHeight: '20px',
            display: 'block',
            position: 'relative',
            textAlign: 'left',
            padding: '10px 0',
            lineHeight: '28px',
            fontSize: '17px',
            color: 'white',
            [theme.breakpoints.up('xl')]: {
                fontSize: '18px',
                color: 'white'
            },

            '&:hover': {
                textDecoration: 'none !important'
            }
        },
        activeLink: {
            width: '3px',
            height: 'calc(100% - 8px)',
            left: '0',
            background: '#CC7191',
            boxShadow: '5px 0px 25px rgba(0, 0, 0, 0.1)',
            borderTopRightRadius: '5px',
            borderBottomRightRadius: '5px',
            position: 'absolute',
            top: '5px',
        },

        active: {
            color: 'white !important',
        },
        deactive: {
            color: '#999 !important'
        },

        logoutBtn: {
            background: '#faf1f4 !important',
            width: '200px',
            height: '50px',
            boxShadow: '0px 5px 20px rgba(44, 108, 249, 0.2) !important',
            borderRadius: '14px !important',
            color: '#CC7191',
            '&:hover': {
                boxShadow: 'none !important',
                backgroundColor: '#faf1f4 !important',
                transition: '.5s linear !important'
            }
        }

    };
});

// inline styles
const link = {
    fontSize: 'inherit',
    fontWeight: '400',
    lineHeight: '28px',
    color: 'inherit'
}

// ----------------------------------------------------------------------

NavBar.propTypes = {
    onCloseNav: PropTypes.func,
    isOpenNav: PropTypes.bool
};

function NavBar({ isOpenNav, onCloseNav }) {
    const classes = useStyles();
    const { pathname } = useLocation();
    const MenuLinks = [
        { link: 'Users', pathname: '/' },
        { link: 'Subscribes', pathname: '/subscribes' },
        { link: 'Articles', pathname: '/articles' },
        { link: 'Suggest Resources', pathname: '/suggested-resources'},
        { link: 'Pawfficehours', pathname: '/pawffices' },
        { link: 'Referral Codes', pathname: '/referral-codes' },
        { link: 'Community Groups', pathname: '/community-groups'},
        { link: 'Suggest Tags', pathname: '/suggested-tags'},
        { link: 'Comments', pathname: '/comments'},
        { link: 'Reports', pathname: '/reports'},
    ]

    const renderContent = (<>
        <Box className={classes.logoBanner}>
            <RouterLink to="/">
                <svg width="200px" height="57" viewBox="0 0 223 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M126.863 56.9988C122.944 54.1679 122.928 50.1441 123.805 46.0904C126.293 34.5837 128.963 23.1163 131.563 11.6339C131.663 11.1901 131.779 10.7487 131.885 10.3164C126.379 8.02733 119.54 8.81803 116.613 12.4626C112.568 17.4973 113.779 22.7566 116.631 27.9077C113.343 30.4285 108.458 28.544 106.746 24.0972C104.837 19.1409 106.496 13.2095 110.929 9.32168C115.899 4.96246 121.824 3.61159 128.262 4.12566C134.177 4.59824 140.073 5.35902 145.995 5.6783C149.35 5.83865 152.713 5.63263 156.023 5.06393C156.311 5.71237 156.46 6.41405 156.46 7.12365C156.46 7.83325 156.311 8.53493 156.023 9.18337C155.6 9.89159 155.036 10.505 154.366 10.9852C153.695 11.4653 152.933 11.8019 152.126 11.9739C149.648 12.2741 147.141 12.247 144.67 11.8932C142.941 11.7779 141.219 11.4161 139.22 11.1233C136.198 26.5073 133.202 41.7542 130.208 56.9976L126.863 56.9988ZM21.5189 56.9988C18.1106 54.8422 17.0825 51.7359 17.9054 47.93C20.4358 36.2355 22.9781 24.544 25.5323 12.8557C25.7271 11.9647 25.9933 11.091 26.2907 9.96489C20.8446 9.18226 15.4688 7.75531 11.0242 12.3243C7.7531 15.6865 7.75772 20.1621 10.8467 28.0483C7.34508 30.2798 2.80835 28.491 1.06789 24.194C-0.850074 19.4567 0.791289 13.4112 5.00182 9.59485C9.75754 5.28519 15.455 3.76606 21.7148 4.20291C27.5471 4.60978 33.3563 5.44314 39.1886 5.67942C42.3398 5.80621 45.5222 5.00744 48.7011 4.7942C49.0809 4.80862 49.4514 4.91524 49.7807 5.1048C50.1101 5.29436 50.3883 5.56121 50.5915 5.88231C50.8556 6.58641 50.942 7.34474 50.843 8.09019C50.744 8.83565 50.4626 9.54515 50.0239 10.1559C49.5851 10.7666 49.0026 11.2598 48.3277 11.5915C47.6529 11.9233 46.9066 12.0836 46.155 12.058C42.64 12.0498 39.1284 11.8401 35.6373 11.4299C35.0103 11.3861 34.3879 11.2777 33.5465 11.1728C31.9329 19.3276 30.3192 27.3545 28.7447 35.3871C27.4491 41.9847 26.1916 48.5904 24.8972 55.1891C24.7376 55.8049 24.5386 56.4098 24.3013 57L21.5189 56.9988ZM41.8327 51.9952C37.9956 47.9876 37.5196 43.097 38.3391 38.0347C39.2885 31.9326 42.5541 26.4316 47.4564 22.676C48.9975 21.3931 50.7991 20.4605 52.7364 19.9431C54.6737 19.4256 56.7004 19.3355 58.676 19.6792C65.601 20.8595 68.162 27.1044 63.9515 32.7707C60.534 37.372 55.5109 39.5181 50.12 40.9266C48.8798 41.2517 47.6027 41.4361 46.3751 41.6793C45.7988 48.0637 49.9483 52.0241 56.1529 51.2288C61.0744 50.5675 65.5735 48.0981 68.7741 44.3015C69.4219 43.4245 69.8335 42.3957 69.9694 41.3139C72.4506 28.1902 74.8988 15.0756 77.3139 1.97026C81.4068 1.2395 84.8059 4.39998 84.0959 8.229C81.9255 19.9143 79.7044 31.5892 77.5179 43.2687C77.2923 44.1641 77.1937 45.0868 77.2251 46.0097C77.3496 47.2234 77.4142 49.1114 78.1126 49.4422C78.7489 49.6461 79.4206 49.7152 80.085 49.6452C80.7494 49.5751 81.392 49.3674 81.9716 49.0353C85.0572 47.2372 87.389 44.9032 88.0598 40.9969C90.2244 28.4656 92.7337 15.9943 94.9847 3.47794C95.3478 1.46431 96.3021 1.14961 97.8259 1.84349C100.812 3.20128 102.884 4.96247 102.08 8.81108C99.6321 20.5356 97.5101 32.3246 95.4469 44.1251C95.1438 45.8541 95.1899 48.6734 96.2146 49.4007C98.2432 50.8403 100.409 49.0676 102.045 47.5461C103.389 46.2967 104.451 44.7533 105.733 43.4244C106.106 43.0348 107.1 42.606 107.259 42.7581C107.713 43.195 108.223 44.0053 108.095 44.517C107.844 45.6866 107.334 46.7851 106.603 47.7317C104.934 49.8234 103.067 51.7498 101.029 53.4844C95.3582 57.9796 90.3097 56.7118 87.0189 50.0854C77.4188 58.2136 72.5766 58.0246 68.8075 49.4433C66.5023 50.9268 64.295 52.5669 61.8918 53.8475C58.9868 55.4578 55.7302 56.3286 52.4092 56.3833C50.4388 56.4172 48.4824 56.0452 46.662 55.2902C44.8417 54.5353 43.1962 53.4137 41.8281 51.9952H41.8327ZM53.4407 24.8383C49.5022 28.3192 47.597 32.992 46.434 38.7378C52.6524 36.9778 56.8951 33.7158 58.8823 28.1395C59.3572 26.807 58.4327 24.9801 58.1503 23.3814C56.5528 23.8402 54.5565 23.8494 53.4407 24.8383ZM201.343 50.3459C191.2 58.0016 186.589 57.8552 183.159 49.0388C182.249 50.291 181.252 51.478 180.176 52.5912C177.479 55.0117 174.528 56.955 170.646 55.4301C167.406 54.1622 165.948 51.4328 165.709 46.3243C164.536 48.1236 163.574 49.7545 162.459 51.2806C159.722 55.0232 156.126 57.1314 151.41 55.7759C146.855 54.4676 144.725 50.7965 144.285 46.4316C143.748 42.2913 144.171 38.083 145.522 34.1327C146.873 30.1823 149.115 26.5958 152.074 23.6511C154.291 21.2944 157.266 19.7928 160.479 19.409C163.692 19.0253 166.937 19.784 169.647 21.5522C171.083 22.4293 172.255 22.9561 173.952 22.1158C174.806 21.6928 176.555 21.6098 176.979 22.1227C177.526 23.1168 177.673 24.2825 177.389 25.3812C176.196 31.708 174.716 37.9852 173.688 44.3361C173.417 46.0132 174.404 47.8908 174.813 49.6773C176.677 48.8797 178.797 48.4095 180.354 47.2211C184.832 43.7944 184.901 38.4127 185.886 33.5049C186.72 29.3554 187.469 25.1795 188.06 20.9885C188.309 19.2158 189.187 19.089 190.534 19.4521C192.07 19.9708 193.379 21.0084 194.234 22.3868C195.089 23.7651 195.437 25.398 195.219 27.0053C194.103 32.9805 192.829 38.9279 191.845 44.9239C191.602 46.3981 192.223 48.0129 192.448 49.5632C194.17 49.1725 196.186 49.2175 197.554 48.2954C198.911 47.4273 200.065 46.2785 200.94 44.9265C201.815 43.5744 202.39 42.0505 202.626 40.4575C204.712 28.106 207.141 15.811 209.35 3.47907C209.705 1.49656 210.635 1.29829 212.247 1.87691C215.804 3.15286 217.073 5.37168 216.369 9.15804C214.127 21.2064 211.834 33.2478 209.713 45.3135C209.472 46.6828 210.2 48.2192 210.478 49.6785C211.969 49.3822 213.749 49.4906 214.89 48.6964C216.732 47.3206 218.367 45.6877 219.745 43.8474C220.695 42.6521 221.497 42.4031 222.724 43.165V45.3792C220.932 47.8023 218.986 50.1073 216.898 52.2799C214.051 54.9137 211.544 56.2277 209.229 56.2277C206.403 56.2207 203.858 54.259 201.339 50.347L201.343 50.3459ZM163.449 23.6846C161.318 24.0255 159.372 25.0986 157.946 26.7194C153.997 31.489 152.504 37.2728 152.248 43.3863C152.087 47.1807 152.797 49.5436 154.537 49.9563C157.486 50.6478 159.038 48.4578 160.696 46.6217C160.934 46.3404 161.157 46.0465 161.364 45.7411C164.735 40.8927 167.051 35.3917 168.165 29.5929C168.81 26.5961 166.897 23.6534 163.986 23.6534C163.806 23.6532 163.625 23.664 163.446 23.6857L163.449 23.6846Z" fill="white" />
                    <path d="M190.671 14.9338C188.656 14.7874 187.674 13.7903 187.508 12.1928C187.544 10.125 192.393 5.55258 194.122 5.62289C196.542 5.72893 200.519 12.1744 199.166 14.1638C198.724 14.6178 198.196 14.9794 197.613 15.2276C197.03 15.4757 196.404 15.6055 195.77 15.6092C195.682 15.6092 195.595 15.6092 195.507 15.6092C193.906 15.6196 192.293 15.0513 190.671 14.9338ZM199.324 7.44173C199.297 6.92398 199.478 6.41695 199.825 6.03176C200.172 5.64657 200.657 5.41459 201.175 5.38658C201.692 5.36051 202.199 5.54049 202.584 5.88719C202.969 6.2339 203.202 6.71907 203.23 7.23652C203.256 7.75427 203.076 8.26129 202.729 8.64648C202.382 9.03167 201.896 9.26366 201.379 9.29167H201.275C200.775 9.29068 200.294 9.09854 199.931 8.75461C199.568 8.41068 199.35 7.94101 199.322 7.44173H199.324ZM186.373 5.8822C186.347 5.36464 186.527 4.85781 186.873 4.47266C187.22 4.0875 187.705 3.85535 188.223 3.82705C188.74 3.80098 189.247 3.98103 189.632 4.32774C190.017 4.67444 190.25 5.15961 190.278 5.67706C190.304 6.19462 190.124 6.70144 189.777 7.0866C189.43 7.47176 188.945 7.70383 188.428 7.73214H188.324C187.824 7.73086 187.344 7.53863 186.981 7.19473C186.618 6.85083 186.401 6.38128 186.373 5.8822ZM195.741 3.15281C195.715 2.63525 195.895 2.12843 196.242 1.74327C196.589 1.35811 197.074 1.12597 197.591 1.09766C198.109 1.07159 198.616 1.25175 199.001 1.5987C199.386 1.94565 199.618 2.43114 199.646 2.9488C199.672 3.46636 199.492 3.97318 199.146 4.35834C198.799 4.74349 198.314 4.97557 197.796 5.00387H197.691C197.192 5.00229 196.711 4.80974 196.349 4.46562C195.986 4.12151 195.769 3.6519 195.741 3.15281ZM190.66 2.29988C190.634 1.78213 190.815 1.27511 191.161 0.889918C191.508 0.504728 191.994 0.272742 192.512 0.244733C193.029 0.218658 193.536 0.398641 193.921 0.745347C194.306 1.09205 194.538 1.57722 194.567 2.09467C194.593 2.61242 194.413 3.11944 194.066 3.50463C193.719 3.88982 193.233 4.12181 192.716 4.14982H192.611C192.111 4.14825 191.631 3.95586 191.268 3.61199C190.906 3.26812 190.688 2.79876 190.66 2.29988Z" fill="white" />
                </svg>
            </RouterLink>
        </Box>

        <Box className={classes.sideBarContent}>
            <Box>
                {
                    MenuLinks.map((list, index) => (
                        <Link
                            // disablePadding
                            key={index}
                            component={RouterLink}
                            to={list.pathname}
                            className={clsx(classes.links, pathname === list.pathname ? classes.active : classes.deactive)}
                            sx={{ textDecoration: 'none' }}
                            onClick={onCloseNav}
                        >
                            {pathname === list.pathname && <div className={classes.activeLink}></div>}

                            <Box sx={{ ml: 4 }}>
                                <Typography variant="subtitle2" sx={{ ...link }}>
                                    {list.link}
                                </Typography>
                            </Box>
                        </Link>
                    ))
                }
            </Box>
            <Box>
                {/* <div className={classes.doc}>
                    <Button
                        fullWidth
                        to={'/'}
                        variant="contained"
                        component={RouterLink}
                        className={classes.logoutBtn}
                    >
                        <Typography variant="subtitle2" style={{ color: '#CC7191' }}>
                            Logout
                        </Typography>
                    </Button>
                </div> */}
            </Box>
        </Box>
    </>);

    return (
        <nav className={classes.drawer}>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"               
                onClickAway={onCloseNav}
            >
                <Hidden lgUp>
                    <Drawer
                        anchor="left"
                        open={isOpenNav}
                        variant="temporary"
                        onClose={onCloseNav}
                        classes={{ paper: classes.drawerPaper }}
                    >
                        {renderContent}
                    </Drawer>
                </Hidden>
            </ClickAwayListener>

            <Hidden lgDown>
                <Drawer
                    open
                    anchor="left"
                    variant="persistent"
                    classes={{ paper: classes.drawerPaper }}
                >
                    {renderContent}
                </Drawer>
            </Hidden>
        </nav>
    );
}

export default NavBar;
